var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('div',{class:{ clickable: _vm.sortable, td: 1 },on:{"click":_vm.changeSort}},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.sortable && _vm.value && _vm.value.field === _vm.field)?_c('fa-icon',{attrs:{"icon":_vm.value.order === 1? 'sort-alpha-down' : 'sort-alpha-up'}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }